import { css } from "@emotion/react";

export const layoutStyles = {
  layout: css({
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  contentContainer: ({ blur = false }: { blur?: boolean }) =>
    css({
      flexGrow: 1,
      filter: blur ? "blur(5px)" : undefined,
      display: "flex",
      flexDirection: "column",

      "> div": {
        flex: "1 1 auto",
      },
    }),
};
